
import React from 'react'
import css from './ReceiptAddress.module.css'

const ReceiptAddress = () => (
  <div className={css.main}>
    <address>
      Segment, Inc.<br />
      101 15th Street<br />
      San Francisco, CA 94103
    </address>
  </div>
)

export default ReceiptAddress



// WEBPACK FOOTER //
// ./components/ReceiptAddress.js